export default "__VITE_ASSET__Czq8BOpm__"